export default __webpack_public_path__ + "static/media/IMG-20250105-WA0017.6bd6f16a.jpg";